import { h } from "preact"
import { useEffect } from "preact/hooks";


export default function RedirectUrl({ url }) {
    useEffect(() => {
        window.location.href = url;
    }, [url]);

    return null;
}